<template>
    <v-card color="black" class="score-totals rounded-lg" flat>
        <template v-for="(side, index) in sides">
            <div v-if="index > 0" :key="`d-${side.key}`" class="score-totals-divider custom-orange" />
            <div :key="side.key" class="score-totals-row" :style="{ borderLeftColor: side.color }">
                <img
                    v-if="side.team.logo"
                    :src="`${assetsUrl}/${side.team.logo}`"
                    class="score-totals-logo"
                >
                <span class="score-totals-name">{{ side.team.name }}</span>
                <span class="score-totals-score" :class="{ 'custom-orange-text': side.leading }">{{ side.score }}</span>
            </div>
        </template>
    </v-card>
</template>

<script>
    // Compact two-row scoreboard (team totals only) for the broadcast screens' left column
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    export default {
        name: 'ScoreTotalsCard',
        props: {
            match: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            team1Score() {
                return this.teamScore(this.match.team1Score, this.match.team1)
            },
            team2Score() {
                return this.teamScore(this.match.team2Score, this.match.team2)
            },
            sides() {
                const colors = getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.black)
                return [
                    { key: 'team1', team: this.match.team1 || {}, color: colors.team1, score: this.team1Score, leading: this.team1Score > this.team2Score },
                    { key: 'team2', team: this.match.team2 || {}, color: colors.team2, score: this.team2Score, leading: this.team2Score > this.team1Score }
                ]
            }
        },
        methods: {
            // Prefer the match score; fall back to summing the players' points
            teamScore(score, team) {
                if (Number(score) > 0) return Number(score)
                return (team?.players || []).reduce((sum, player) => sum + (Number(player?.stats?.[0]?.points) || 0), 0)
            }
        }
    }
</script>

<style scoped>
/* no padding on the card: the rows (and their team colour strips) reach its top and bottom edges,
   and the rounded corners clip them */
.score-totals {
    min-width: 500px;
    padding: 0;
    overflow: hidden;
    color: white;
}

.score-totals-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 15px 28px 15px 20px;
    border-left: 8px solid transparent;
}

.score-totals-divider {
    height: 3px;
}

.score-totals-logo {
    width: 56px;
    height: 56px;
    object-fit: contain;
}

.score-totals-name {
    flex: 1 1 auto;
    min-width: 0;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.score-totals-score {
    font-size: 1.6em;
    font-weight: bold;
    min-width: 60px;
    text-align: right;
}
</style>
